<div class="container mt-5">
  <div *ngIf="privacyPolicyContent">
    
    <div [innerHTML]="privacyPolicyContent.body"></div>
  </div>
</div>
